/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import jsPDF from 'jspdf';
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev } from '../../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Export Rapor';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'penilaian';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null)
    const [data_mapel, set_data_mapel] = useState(null);
    const [data_kelas, set_data_kelas] = useState(null);
    const [data_tahun, set_data_tahun] = useState(null);
    const [data_kategori_nilai, set_data_ketegori_nilai] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')
    const [nis, set_nis] = useState('')
    const [nama, set_nama] = useState('')
    const [mapel, set_mapel] = useState('')
    const [kelas, set_kelas] = useState('')
    const [kategori, set_kategori] = useState('')
    const [nilai, set_nilai] = useState('')
    const [tahun, set_tahun] = useState('')

    const [filter_kelas, set_filter_kelas] = useState('')
    const [filter_kategori, set_filter_kategori] = useState('')
    const [filter_tahun, set_filter_tahun] = useState('')

    const [identitas_nama, set_identitas_nama] = useState('')
    const [identitas_alamat, set_identitas_alamat] = useState('')
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/penilaian/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
            + '&filter_kelas=' + filter_kelas
            + '&filter_kategori=' + filter_kategori
            + '&filter_tahun=' + filter_tahun

        , 
		).then((response) => {
            console_dev('response read', response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_mapel = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_mapel_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read kelas', response.data)
            if(response.data.result == 'success'){
                set_data_mapel(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_kelas = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_kelas_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read kelas', response.data)
            if(response.data.result == 'success'){
                set_data_kelas(response.data.data)
                set_filter_kelas(response.data.data.list[0].kelas)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_ketegori_nilai = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_kategori_nilai_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read kelas', response.data)
            if(response.data.result == 'success'){
                set_data_ketegori_nilai(response.data.data)
                set_filter_kategori(response.data.data.list[0].kode)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_tahun = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/master/get__________?action=read_tahun_all`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read tahun', response.data)
            if(response.data.result == 'success'){
                set_data_tahun(response.data.data)
                set_filter_tahun(response.data.data.list[0].tahun)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_identitas = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`sims/identitas/get__________?action=read_identitas_only`
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response read identitas', response.data)
            if(response.data.result == 'success'){
                set_identitas_nama(response.data.data.list[0].nama_sekolah)
                set_identitas_alamat(response.data.data.list[0].alamat)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search = () => {

        if(loading === true){
            return
        }
        
        if(search.length > 8){
    
            API_GET_REQUEST(`sims/penilaian/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
                + '&filter_kelas=' + filter_kelas
                + '&filter_kategori=' + filter_kategori
                + '&filter_tahun=' + filter_tahun
            , 
            ).then((response) => {
                console_dev('response search', response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    set_nama(response.data.data.list[0].nama)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                    set_nama('')
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads = (action) => {

        if(loading === true){
            return
        }

        loading(true);

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + "sims/penilaian/post__________",
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev('response uploads', response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
		})

    }

    const _uploads_post = (params) => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('sims/penilaian/post__________', {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            nis: nis,
            nama: nama,
            mapel: mapel,
            kelas: kelas,
            kategori: kategori,
            nilai: nilai,
            tahun: tahun,
		}).then((response) => {
            console_dev('response upload post', response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')
                set_nis('')
                set_nama('')
                set_mapel('')
                set_kelas('')
                set_kategori('')
                set_nilai('')
                set_tahun('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};

    const _export_pdf = () => {

        let doc = new jsPDF('p','px',[794, 1123], true);

        doc.html(document.querySelector("#export_pdf"), {
            callback : function(pdf){
                let base64 = pdf.output('dataurlstring');
                console.log('pdf base64 : ', base64)
                let blob = new Blob([pdf.output('arraybuffer')], { type : 'application/pdf'})
                console.log('pdf blob : ', blob)
                let blobUrl = URL.createObjectURL(blob);
                console.log('blob url : ', blobUrl)

                window.open(blobUrl);
            }
        })

    }
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== null){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                // _read(1, storage_bamboo)
                _read_mapel(storage_bamboo)
                _read_kelas(storage_bamboo)
                _read_ketegori_nilai(storage_bamboo)
                _read_tahun(storage_bamboo)
                _read_identitas(storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }

    const _STORAGE_USER_ONLY_READ = () => {

        if(STORAGE_USER !== null){

            let storage_bamboo = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                // _read(1, storage_bamboo)
            }

        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(STORAGE_USER !== undefined){
        if(STORAGE_USER[0].level === 'guest'){
            history.push('/')
        }
    }else{
        history.push('/home')
        window.location.reload();
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search])

    useEffect(() => {

        _STORAGE_USER_ONLY_READ()
        set_search('')
        set_nama('')

    }, [filter_kelas])

    useEffect(() => {

        _STORAGE_USER_ONLY_READ()
        set_search('')
        set_nama('')

    }, [filter_kategori])

    useEffect(() => {

        _STORAGE_USER_ONLY_READ()
        set_search('')
        set_nama('')

    }, [filter_tahun])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <div style={{padding: 20}}>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Header ------------------------------------------------------------------ */}
            <div className="_row _center_align _no_print">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d _no_print">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian {meta_title}</p>
            </div>
            {/*  End Header --------------------------------------------------------------- */}

            {/*  Add ---------------------------------------------------------------------- */}
            <div className="_row _center_align _push_b_d _no_print">
                <div className="_column">
                    <div className="_font_size_20px">Data Cloud <ion-icon name="cloud-done-outline" style={{fontSize: 30, marginBottom: -6, marginLeft: 8, color: 'seagreen'}}></ion-icon></div>
                </div>
                <div>
                    <div
                        onClick={() => {
                            window.print()
                        }}
                        className="_btn _cursor_pointer"
                    >
                        Print
                    </div>
                </div>
            </div>
            {/*  Add ---------------------------------------------------------------------- */}

            <div className="_row_auto _center_align _push_b_d _no_print" style={{marginLeft: -10, marginRight: -10}}>
                <div className="_row _center_align">
                    <div className="_push_r_m" style={{marginLeft: 10}}>
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'dropdown_filter_kelas'){
                                    set_element(null)
                                }else{
                                    set_element('dropdown_filter_kelas')
                                }
                            }} className="_btn _cursor_pointer" style={{backgroundColor: element === 'dropdown_filter_kelas' ? '#eee' : null,  borderColor: '#eee', borderRadius: 0, paddingTop: 12, paddingBottom: 12}}>
                                <div className="_row _center_align">
                                    <div className="_column">
                                        {filter_kelas.length > 0 ? filter_kelas : 'Kelas'}
                                    </div>
                                    <div className="_push_l_m _push_t_t">
                                        {
                                            element === 'dropdown_filter_kelas' ?
                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                            :
                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                element === 'dropdown_filter_kelas' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left">
                                            {
                                                data_kelas && data_kelas.list.map((item, index) => (
                                                    <div key={index} onClick={() => {set_filter_kelas(item.kelas)}} className="_item" style={{backgroundColor: filter_kelas === item.kelas ? '#eee' : null}}>{item.kelas}</div>
                                                ))
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    </div>
                    <div className="_push_r_m">
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'dropdown_filter_kategori'){
                                    set_element(null)
                                }else{
                                    set_element('dropdown_filter_kategori')
                                }
                            }} className="_btn _cursor_pointer" style={{backgroundColor: element === 'dropdown_filter_kategori' ? '#eee' : null,  borderColor: '#eee', borderRadius: 0, paddingTop: 12, paddingBottom: 12}}>
                                <div className="_row _center_align">
                                    <div className="_column">
                                        {filter_kategori.length > 0 ? filter_kategori : 'Kategori'}
                                    </div>
                                    <div className="_push_l_m _push_t_t">
                                        {
                                            element === 'dropdown_filter_kategori' ?
                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                            :
                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                element === 'dropdown_filter_kategori' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left">
                                            {
                                                data_kategori_nilai && data_kategori_nilai.list.map((item, index) => (
                                                    <div key={index} onClick={() => {set_filter_kategori(item.kode)}} className="_item" style={{backgroundColor: filter_kategori === item.kode ? '#eee' : null}}>{item.kode} - {item.nama}</div>
                                                ))
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    </div>
                    <div style={{marginRight: 10}}>
                        <div className="_relative">
                            <div onClick={() => {
                                if(element === 'dropdown_filter_tahun'){
                                    set_element(null)
                                }else{
                                    set_element('dropdown_filter_tahun')
                                }
                            }} className="_btn _cursor_pointer" style={{backgroundColor: element === 'dropdown_filter_tahun' ? '#eee' : null,  borderColor: '#eee', borderRadius: 0, paddingTop: 12, paddingBottom: 12}}>
                                <div className="_row _center_align">
                                    <div className="_column">
                                        {filter_tahun.length > 0 ? filter_tahun : 'Tahun'}
                                    </div>
                                    <div className="_push_l_m _push_t_t">
                                        {
                                            element === 'dropdown_filter_tahun' ?
                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                            :
                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                element === 'dropdown_filter_tahun' ?
                                    // _left or _right
                                    <>
                                        <div className="_fmc_overlay_dropdown _left">
                                            {
                                                data_tahun && data_tahun.list.map((item, index) => (
                                                    <div key={index} onClick={() => {set_filter_tahun(item.tahun)}} className="_item" style={{backgroundColor: filter_tahun === item.tahun ? '#eee' : null}}>{item.tahun}</div>
                                                ))
                                            }
                                        </div>
                                    </>
                                : null
                            }
                        </div>
                    </div>
                </div>
                <div className="_column_auto">
                    {/*  Search -------------------------------------------------------------------- */}
                    <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                        <div className="_row _center_align">
                            <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                            <div className="_column">
                                <input 
                                    placeholder="Cari NIS" 
                                    onChange={e => set_search(e.target.value)}
                                    value={search}
                                />
                            </div>
                        </div>
                    </div>
                    {/*  End Search ---------------------------------------------------------------- */}
                </div>
            </div>

            {/*  Table --------------------------------------------------------------------- */}
            <div id="export_pdf">

                <div style={{paddingLeft: 14, paddingTop: 20, paddingRight: 14}}>

                    <div className="_row">
                        <div className="_column">
                            <div className="_row _center_align _push_b_s">
                                <div style={{width: 150}}>
                                    Nama Sekolah
                                </div>
                                <div style={{width: 20, textAlign: 'center'}}>
                                    :
                                </div>
                                <div className="_column">
                                    {identitas_nama.length > 0 ? identitas_nama : '...'}
                                </div>
                            </div>
                            <div className="_row _center_align _push_b_s">
                                <div style={{width: 150}}>
                                    Alamat
                                </div>
                                <div style={{width: 20, textAlign: 'center'}}>
                                    :
                                </div>
                                <div className="_column">
                                    {identitas_alamat.length > 0 ? identitas_alamat : '...'}
                                </div>
                            </div>
                            <div className="_row _center_align _push_b_s">
                                <div style={{width: 150}}>
                                    Nama Peserta Didik
                                </div>
                                <div style={{width: 20, textAlign: 'center'}}>
                                    :
                                </div>
                                <div className="_column">
                                    {nama.length > 0 ? nama : '...'}
                                </div>
                            </div>
                            <div className="_row _center_align _push_b_s">
                                <div style={{width: 150}}>
                                    Nomor Induk/NIS
                                </div>
                                <div style={{width: 20, textAlign: 'center'}}>
                                    :
                                </div>
                                <div className="_column">
                                    {search.length > 0 ? search : '...'}
                                </div>
                            </div>
                        </div>
                        
                        <div className="_column">
                            <div className="_row _center_align _push_b_s">
                                <div style={{width: 150}}>
                                    Keterangan Nilai 
                                </div>
                                <div style={{width: 20, textAlign: 'center'}}>
                                    :
                                </div>
                                <div className="_column">
                                    {filter_kategori.length > 0 ? filter_kategori : '...'}
                                </div>
                            </div>
                            <div className="_row _center_align _push_b_s">
                                <div style={{width: 150}}>
                                    Kelas
                                </div>
                                <div style={{width: 20, textAlign: 'center'}}>
                                    :
                                </div>
                                <div className="_column">
                                    {filter_kelas.length > 0 ? filter_kelas : '...'}
                                </div>
                            </div>
                            <div className="_row _center_align _push_b_s">
                                <div style={{width: 150}}>
                                    Tahun Ajaran
                                </div>
                                <div style={{width: 20, textAlign: 'center'}}>
                                    :
                                </div>
                                <div className="_column">
                                    {filter_tahun.length > 0 ? filter_tahun : '...'}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                
                <table className="_table _push_t_d">
                    <thead>
                        <tr>
                            <th colSpan={2}>Mata Pelajaran</th>
                            <th>Nilai</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <td style={{width: 60}}>
                                {
                                    data_mapel && data_mapel.list.map((item, index) => (
                                        <>
                                            <div key={index} className="_push_b_m _push_t_m">{index + 1}</div>
                                            <div style={{borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid'}}></div>
                                        </>
                                    ))
                                }
                            </td>
                            <td>
                                {
                                    data_mapel && data_mapel.list.map((item, index) => (
                                        <>
                                            <div key={index} className="_push_b_m _push_t_m">{item.mapel}</div>
                                            <div style={{borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid'}}></div>
                                        </>
                                    ))
                                }
                            </td>
                            <td style={{verticalAlign: 'top', width: 100}}>
                                {
                                    data && 
                                        data.list.map((item, index) => (
                                            <div key={index}>
                                                {
                                                    JSON.parse(decode(item.nilai)).map((x, i) => (
                                                        <>
                                                            <div className="_push_b_m _push_t_m">{decode(x.value)}</div>
                                                            <div style={{borderBottomWidth: 1, borderBottomColor: '#eee', borderBottomStyle: 'solid'}}></div>
                                                        </>
                                                    ))
                                                }
                                            </div>
                                        ))
                                }
                            </td>
                        </tr>
                    </thead>
                </table>
                
            </div>
            {/*  End Table ----------------------------------------------------------------- */}

            {/*  Pagination ---------------------------------------------------------------- */}
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1, bamboo_user);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>
            {/*  End Pagination -------------------------------------------------------------*/}

            {/*  Credit -------------------------------------------------------------------- */}
            {
                data&&data.pages.length === 1 &&
                <div className="_row _push_b_g _fmc_hide_mobile">
                    <div className="_fmc_overlay_bg_hide" style={{paddingLeft: 10, paddingRight: 40}}>
                        <img style={{width: 400}} src={OverlayBg}/>
                    </div>
                    <div className="_column">
                        <div className="_heading_bold _push_b_l" style={{maxWidth: 500}}>
                            Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                        </div>
                        <div className="_relative _push_b_d">
                            <p style={{color: '#888', fontSize: 13}}>
                                Design Eksklusif Oleh
                            </p>
                            <p style={{color: '#444', fontSize: 16}}>
                                Andika Chamberlin
                            </p>
                            <p style={{color: '#888', fontSize: 13, marginTop: 10}}>
                                Didukung Oleh
                            </p>
                            <p style={{color: '#444', fontSize: 16}}>
                                Flamecore Cloud & Digitali
                            </p>
                        </div>
                    </div>
                </div>
            }
            {/*  End Credit ---------------------------------------------------------------- */}

            {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </div>
    );

}

export default Screen;